import state from './moduleChatSettingsState'
import actions from './moduleChatSettingsActions'
import getters from './moduleChatSettingsGetters'
import mutations from './moduleChatSettingsMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
